export default "__VITE_ASSET__epOYTszY__"